<template>
    <div class="userCenter_right">
        <h4>安全设置</h4>
        <div v-if="!accontShow">
        <!-- <div v-if="!resetShow && !accontShow"> -->
            <div class="security">
                <div class="security_left">
                    <p class="iconfont security_left_icons">&#xe8d4;</p>
                    <div class="security_left_text">
                        <h3>重置账号密码</h3>
                        <p>上次重置：{{moment(isUsermessage.changePwdDate).format('YYYY年MM月DD日')}}</p>
                    </div>
                </div>
                <div class="security_right">
                    <el-button type="primary" plain @click="resetPassword">重置</el-button>
                </div>
            </div>
            <div class="security">
                <div class="security_left">
                    <p class="iconfont security_left_icons security_left_icons2">&#xe62c;</p>
                    <div class="security_left_text">
                        <h3>销户</h3>
                        <p>永久删除您的账户及相关数据，管理您的注销请求</p>
                    </div>
                </div>
                <div class="security_right">
                    <i class="el-icon-arrow-right icons" @click="cancellationAccount"></i>
                </div>
            </div>
        </div>
        <!-- <reset-password  v-if="resetShow" @resetShowMess="resetShowMess"></reset-password> -->
        <cancellation-account v-if="accontShow" @accountShowMess="accountShowMess"></cancellation-account>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    // import resetPassword from "./resetPassword"
    import cancellationAccount from "./cancellationAccount"

    export default {
        name: "securitySettings",
        components: {
            // resetPassword,
            cancellationAccount
        },
        data(){
            return {
                // resetShow: false,
                accontShow: false,
            }
        },
      computed: {
        ...mapState({
          isUsermessage: "isUsermessage",
          isLogin: "isLogin",
        }),
      },
        methods: {
            // ...mapMutations([]),
            init(){
            },
            // 重置按钮
            resetPassword(){
                this.$router.push('/forgetPassword')
                // this.resetShow = true
            },
            // 重置页面取消后的返回
            // resetShowMess(val){
            //     this.resetShow = val
            // },
            // 销户跳转
            cancellationAccount(){
                this.accontShow = true
            },
            accountShowMess(val){
                this.accontShow = val
            }
        }
    }
</script>

<style scoped lang="less">
    .userCenter_right {
        width: 966px;
        background: #fff;

        h4 {
            color: #009999;
            padding: 20px 18px;
            border-bottom: 2px solid #f9f9f9;
        }
        .security {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #efefef;
            padding: 16px 0;
            margin: 0 30px;

            .security_left {
                display: flex;
                align-items: center;
                .security_left_icons {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 24px;
                    color: #fff;
                    border-radius: 50%;
                    background: #ffaa25;
                    margin-right: 16px;
                    text-align: center;
                }
                .security_left_icons2 {
                    background: #ff6a6f;
                }
                .security_left_text {
                    font-size: 14px;
                    h3 {
                        font-weight: 500;
                    }
                    p {
                        font-size: 12px;
                        color: #666;
                        margin-top: 6px;
                    }
                }
            }
            .security_right {
                /deep/.el-button--primary.is-plain {
                    color: #009999;
                    border-color: #009999;
                    &:hover {
                        background-color: #009999;
                        color: #fff;
                    }
                }
                .icons {
                    color: #666;
                    cursor: pointer;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/securitySettings/index.vue